"use client";
import { jsx } from "react/jsx-runtime";
import { Dialog } from "@base-ui/react/dialog";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
import { useDialogMode } from "./DialogContext.js";
const DialogTrigger_DialogTrigger = /*#__PURE__*/ forwardRef(function(props, ref) {
    const mode = useDialogMode();
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Trigger, {
        ref: ref,
        ...props
    });
    return /*#__PURE__*/ jsx(Dialog.Trigger, {
        ref: ref,
        ...props
    });
});
export { DialogTrigger_DialogTrigger as DialogTrigger };
